export enum UserType {
    Patient = 0,
    Doctor = 1,
    ClinicAdmin = 2
}